<mat-card style="height: 100%; border: 1px solid rgb(216, 217, 217)">
    <mat-card-header>
        <mat-card-title style="font-size: large">Select the Creditors
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <hr />
        <table>
            <thead>
                <th>Creditor</th>
                <th>Balance</th>
                <th>Referral</th>
            </thead>
            <tbody>
                <tr *ngFor="let trade of tradesList; index as tradeIndex">
                    <td *ngIf="trade.Balance > 0 && trade.Type[0] !== 'M'"
                        [ngClass]="{'highlight-referral':trade.Referral == true}">
                        {{ trade.MemberName }}
                    </td>
                    <td *ngIf="trade.Balance > 0 && trade.Type[0] !== 'M'"
                        [ngClass]="{'highlight-referral': trade.Referral == true }">
                        {{ trade.Balance }}
                    </td>
                    <td *ngIf="trade.Balance > 0 && trade.Type[0] !== 'M'"
                        [ngClass]="{'highlight-referral': trade.Referral == true}">
                        <mat-checkbox [(ngModel)]="trade.Referral"></mat-checkbox>
                    </td>
                </tr>
                <tr *ngFor="let collection of collectionList; index as collectionIndex">
                    <td *ngIf="collection.CurrentBalance > 0 && !collectionList.includes('FAMILY SUPPORT')"
                        [ngClass]="{'highlight-referral':collection.Referral == true}">
                        {{ collection.MemberName }}/{{ collection.Creditor }}
                    </td>
                    <td *ngIf="collection.CurrentBalance > 0 && !collectionList.includes('FAMILY SUPPORT')"
                        [ngClass]="{'highlight-referral':collection.Referral == true}">
                        {{ collection.CurrentBalance }}
                    </td>
                    <td *ngIf="collection.CurrentBalance > 0 && !collectionList.includes('FAMILY SUPPORT')"
                        [ngClass]="{'highlight-referral':collection.Referral == true }">
                        <mat-checkbox [(ngModel)]="collection.Referral"></mat-checkbox>
                    </td>
                </tr>
                <tr>
                    <td [ngClass]="{ 'highlight-referral': otherCreditor == true }">
                        <input style="width: 100%" type="text" class="textStyle" placeholder="Please enter creditor"
                            [formControl]="otherCreditor_name" />
                    </td>
                    <td [ngClass]="{ 'highlight-referral': otherCreditor == true }">
                        <input style="width: 100%" type="number" class="textStyle"
                            placeholder="Please enter creditor balance" [formControl]="otherCreditor_amount" />
                    </td>
                    <td [ngClass]="{ 'highlight-referral': otherCreditor == true }">
                        <mat-checkbox [(ngModel)]="otherCreditor" [disabled]="
                    otherCreditor_name.value === '' ||
                    otherCreditor_amount.value === ''
                      ? true
                      : false
                  "></mat-checkbox>
                    </td>
                </tr>
            </tbody>
        </table>
    </mat-card-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" (click)="submitRapidApproval()">
            <span>Submit</span>
        </button>
    </mat-dialog-actions>
</mat-card>